/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f0f93572a0cc7caeb2a18534572e948e107e0f21";
